export default {
  OPERACION_PROYECTO: (state, mutation) => {
    state.operacion = mutation.oper
    state.id = mutation.id
  },
}
